export const slides = $("#new-player .slide") // :not(#loading-slide)
export const slideContainer = $("#slide-container")
export const slideImages = $("#new-player .slide-image")
export const firstImage = slideImages.first()
export const currentImage = $("#new-player .slide.current .slide-image")
export const currentSlide = $("#new-player #current-slide")
export const stage = $("#new-player #stage")
export const progressBar = $("#progress-bar ")
export const player = $("#new-player")
export const toolbar = $("#player-toolbar")

export const getSlideSelectorByIndex = (index) => {
  return `#new-player #slide-${index}`
}

export const TOOLBAR_HEIGHT = 50
export const SLIDE_MARGIN = 7
export const NORMAL_IMAGE_WIDTH = 638
export const FULLSCREEN_IMAGE_WIDTH = 1024
